module.exports = __webpack_public_path__ + "static/TiemposText-RegularItalic-72fbc5c9e68eaaba66758971ec9ce0c7.ttf";